<template>
    <by-effect>
        <template v-slot:header>
            <img src="../../../assets/images/doctor/by-effects/cough.png" alt="effect image">
        </template>

        <template v-slot:content>
            <p>Виявлено в анамнезі:</p>
            <p><strong>ХОЗЛ ІV ступеня (ОФВ 28%)</strong></p>
        </template>
    </by-effect>
</template>

<script>
import ByEffect from './ByEffect';

export default {
    components : {
        'by-effect' : ByEffect
    }
}
</script>